import React from 'react';
import { Checkbox } from 'antd';
import { CartItemType } from '@base/cart/interface';
import type { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { useTrans } from 'base/utils/i18n';

type CartItemCheckboxProps = {
    className?: string;
    item: CartItemType;
    batchActive: boolean;
    onCheckBoxChange?: (e: CheckboxChangeEvent) => void;
};

const CartItemCheckbox: React.FC<CartItemCheckboxProps> = props => {
    const {
        className,
        item: {
            id,
            stockNum,
            isChangingQty,
            groupCanSelect,
        },
        batchActive,
        onCheckBoxChange
    } = props;
    const { t } = useTrans();

    return (
        <Checkbox
            value={id}
            className={className}
            disabled={!batchActive && (isChangingQty || stockNum === 0 || !groupCanSelect)}
            onChange={onCheckBoxChange}
        >
            <span className="visually-hidden">{t('web_form_select_label')}</span>
        </Checkbox>
    );
};

export default CartItemCheckbox;